<template>
	<div v-loading="fullscreenLoading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)" style="width:auto;margin-top: 10px;">
		<div>
			<div class="title">
				<h4>
					菜单权限管理 &nbsp;&nbsp;
					<button @click="look_note">备注说明</button>&nbsp;&nbsp;
					<button @click="fun_show">{{btn_name}}</button>&nbsp;&nbsp;
					<button @click="fun_showbtn">操作管理</button>&nbsp;&nbsp;
					<!-- <button @click="fun_showmore">批量管理</button> -->
				</h4>
				<div id="notice" class="shop_data">
					<div>
						<h5>说明1：按角色划分控制是否可见菜单</h5><br />
						<h5>说明2：对于大多数菜单进行了按钮标准化,可以指定角色是否可以操作</h5><br />
						<h5>说明3：简单权限控制(增加、删除、修改、查询)、复杂权限控制(增加、删除、修改、查询、提交、作废)、全部权限</h5><br />
						<!-- <h5>说明4：批量权限控制,先选择角色范围,再选择具体控制,选择完成后点击保存进行修改。</h5> -->
						<h5>说明4：二级菜单名称不建议超过8个汉字。</h5><br />
						<h5 class="red">说明5：删除按钮在业务审核流程里=一键驳回</h5>
					</div>
				</div>
			</div>

			<div class="select_user" v-show="!show_more">
				<label>角色类型：</label>
				<pre-select class="short" @selectFunc="selectFunc" v-bind:searchList="comtype"
					:selectValue="sel_comtypename" />

				<div>
					&nbsp;&nbsp;&nbsp;&nbsp;
					<label>一级菜单:</label>
					<pre-select class="short" @selectFunc="selectMenuOne" v-bind:searchList="sel_one"
						:selectValue="sel_one_name" />
				</div>
			</div>
			<div class="pre_tab" v-show="show_power">
				<table class="dataintable tab-inline" border="1" cellpadding="2" cellspacing="1">
					<thead>
						<tr>
							<th>序号</th>
							<th class="long1">菜单名称</th>
							<th class="long2">菜单说明</th>
							<th class="short0">是否拥有</th>
							<th class="short0">操作</th>
						</tr>
					</thead>
					<tbody class="tab_body">
						<tr v-for="(item, index) in tabdataBak" :key="index">
							<td>{{ item.id }}</td>
							<td class="long1">{{ item.m_name }}</td>
							<td class="long2">{{ item.m_note }}</td>
							<td class="short0 cen">{{ item.m_has }}</td>
							<td class="short0 cen">
								<!-- <input type="checkbox" v-model="item.state" v-on:change="select_menu(item)" /> -->
								<el-checkbox class="checkleft" v-model="item.state" v-on:change="select_menu(item)">
								</el-checkbox>
							</td>
						</tr>
					</tbody>
				</table>
				<table class="dataintable tab-inline" border="1" cellpadding="2" cellspacing="1">
					<thead>
						<tr>
							<th>序号</th>
							<th class="short1">姓名</th>
						</tr>
					</thead>
					<tbody class="tab_body">
						<tr v-for="(item, index) in list_user" :key="index">
							<td>{{ item.id }}</td>
							<td class="short1">{{ item.u_name }}</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
		<div v-show="show_edit">
			<div class="menu_left">
				<div class="menu_title">一级菜单编辑</div>
				<div class="menu_edit_all">
					<div class="menu_edit">
						<label>名称:</label><input type="text" v-model="m_one_name" />
					</div>
					<div class="menu_edit">
						<label>参数:</label><input type="text" v-model="m_one_val" />
					</div>
					<div class="menu_edit">
						<label>步骤:</label><input type="number" v-model="m_one_step" />
					</div>
					<div class="menu_edit">
						<button @click="fun_menu_edit_one">{{m_one_btn}}</button>
					</div>
				</div>

				<table class="dataintable">

					<tbody>
						<tr>
							<th>序号</th>
							<th class="short1">名称</th>
							<th class="short0">参数</th>
							<th class="short0">排名</th>
							<th class="long1_3">编辑</th>
						</tr>
						<tr v-for="(item, index) in menu_one" :key="index">
							<td>{{ item.id }}</td>
							<td class="short1">{{ item.name }}</td>
							<td class="short0">{{ item.val }}</td>
							<td class="short0">{{ item.step }}</td>
							<td class="long1_3">
								<button @click="fun_menu_one_edit(item,'upd')">编辑</button>
								<button @click="fun_menu_one_edit(item,'add')">新增</button>
								<button @click="fun_menu_one_edit(item,'del')">删除</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
			<div class="menu_right">
				<div class="menu_title">二级菜单编辑</div>
				<div class="menu_edit_all">
					<div class="menu_edit">
						<label>名称:</label><input type="text" v-model="m_two_name" />
					</div>
					<!-- <div class="menu_edit">
            <label>编号:</label><input type="text" v-model="m_two_no" placeholder="为空走自定义菜单!" />
          </div> -->
					<div class="menu_edit">
						<label>参数:</label><input type="text" v-model="m_two_val" />
					</div>
					<div class="menu_edit">
						<label>步骤:</label><input type="number" v-model="m_two_step" />
					</div>
					<div class="menu_edit">
						<button @click="fun_menu_edit_two">{{m_two_btn}}</button>
					</div>
				</div>

				<table class="dataintable">
					<tbody>
						<tr>
							<th>序号</th>
							<th class="long1">名称</th>
							<th class="long1">跳转参数</th>
							<th class="long1">建表参数</th>
							<th class="short-word-2">排名</th>
							<th class="long1_3">编辑</th>
						</tr>
						<tr v-for="(item, index) in menu_two" :key="index">
							<td>{{ item.id }}</td>
							<td class="long1">{{ item.name }}</td>
							<td class="left long1">{{ item.val }}</td>
							<td class="left long1">{{ item.no }}</td>
							<td class="short-word-2">{{ item.step }}</td>
							<td class="long1_3">
								<button @click="fun_menu_two_edit(item,'upd')">编辑</button>
								<button @click="fun_menu_two_edit(item,'add')">新增</button>
								<button @click="fun_menu_two_edit(item,'del')">删除</button>
							</td>
						</tr>
					</tbody>
				</table>

			</div>
		</div>

		<!-- add 按钮控制部分 -->
		<div v-show="show_button_edit">
			<table class="dataintable">
				<thead>
					<tr>
						<th>序号</th>
						<th class="long1">一级菜单</th>
						<th class="long1">二级菜单</th>
						<th class="menu_btn">新建</th>
						<th class="menu_btn">删除</th>
						<th class="menu_btn">修改</th>
						<th class="menu_btn">查询</th>
						<th class="menu_btn">提交</th>
						<th class="menu_btn">作废</th>
						<th class="menu_btn">导出</th>
						<th class="menu_btn">导入</th>
						<th class="short0">文件上传</th>
						<th class="short0">文件预览</th>
						<th class="short0">文件删除</th>
						<th class="menu_btn">打印</th>
						<th class="long1_3">编辑</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(item, index) in menu_btn" :key="index" v-show="fun_check_editbtn(item.m_name)">
						<td>{{ item.id }}</td>
						<td class="long1 left">{{ item.m_name }}</td>
						<td class="long1 left">{{ item.m_note }}</td>
						<td class="menu_btn cen">
							<input type="checkbox" v-model="item.m_add"
								v-on:change="select_menu_btn(item.rowid,'m_add',item.m_add)" />
							<!-- <el-checkbox class="checkleft" v-model="item.m_add"  v-on:change="select_menu_btn(item.rowid,'m_add',item.m_add)" ></el-checkbox> -->
						</td>
						<td class="menu_btn cen">
							<input type="checkbox" v-model="item.m_del"
								v-on:change="select_menu_btn(item.rowid,'m_del',item.m_del)" />
							<!-- <el-checkbox class="checkleft" v-model="item.m_add"  v-on:change="select_menu_btn(item.rowid,'m_add',item.m_add)" ></el-checkbox> -->
						</td>
						<td class="menu_btn cen"><input type="checkbox" v-model="item.m_upd"
								v-on:change="select_menu_btn(item.rowid,'m_upd',item.m_upd)" /></td>
						<td class="menu_btn cen"><input type="checkbox" v-model="item.m_sel"
								v-on:change="select_menu_btn(item.rowid,'m_sel',item.m_sel)" /></td>
						<!-- <td class="menu_btn" ><input type="checkbox" v-model="item.m_sav" v-on:change="select_menu_btn(item.rowid,'m_sav',item.m_sav)" /></td> -->
						<td class="menu_btn cen"><input type="checkbox" v-model="item.m_sub"
								v-on:change="select_menu_btn(item.rowid,'m_sub',item.m_sub)" /></td>
						<td class="menu_btn cen"><input type="checkbox" v-model="item.m_bad"
								v-on:change="select_menu_btn(item.rowid,'m_bad',item.m_bad)" /></td>
						<td class="menu_btn cen"><input type="checkbox" v-model="item.m_exl_down"
								v-on:change="select_menu_btn(item.rowid,'m_exl_down',item.m_exl_down)" /></td>
						<td class="menu_btn cen"><input type="checkbox" v-model="item.m_exl_up"
								v-on:change="select_menu_btn(item.rowid,'m_exl_up',item.m_exl_up)" /></td>
						<td class="short0 cen"><input type="checkbox" v-model="item.m_fileup"
								v-on:change="select_menu_btn(item.rowid,'m_fileup',item.m_fileup)" /></td>
						<td class="short0 cen"><input type="checkbox" v-model="item.m_filelook"
								v-on:change="select_menu_btn(item.rowid,'m_filelook',item.m_filelook)" /></td>
						<td class="short0 cen"><input type="checkbox" v-model="item.m_filedel"
								v-on:change="select_menu_btn(item.rowid,'m_filedel',item.m_filedel)" /></td>
						<td class="menu_btn cen"><input type="checkbox" v-model="item.m_print"
								v-on:change="select_menu_btn(item.rowid,'m_print',item.m_print)" /></td>
						<td class="long1_3">
							<button @click="select_menu_btn(item.rowid,'easy')">简单</button>
							<button @click="select_menu_btn(item.rowid,'more')">复杂</button>
							<button @click="select_menu_btn(item.rowid,'all')">全部</button>
						</td>
					</tr>
				</tbody>
			</table>
		</div>

		<!-- 2021-06-29 add 批量增加 权限  -->
		<div v-show="show_more">
			<div class="content_edit">
				<div class="content_edit_item">
					<label>选择角色名称:</label>
					<span>{{check_r_names}}</span>
					&nbsp;&nbsp;<button @click="fun_sel_is_all('1')">全选</button>
					&nbsp;&nbsp;<button @click="fun_sel_is_all('0')">清空</button>
				</div>
			</div>
			<div class="check-list">
				<el-checkbox-group v-model="check_list">
					<el-checkbox v-for="(item,index) in list_role" :label="item.name" :key="index"
						@change="sel_push(item)"></el-checkbox>
				</el-checkbox-group>
				<!-- <table class="dataintable">
					<thead>
						<tr class="tab_header">
							<th>序号</th>
							<th class="long1">角色名称</th>
							<th>操作</th>
						</tr>
					</thead>
					<tbody class="tab_body">
						<tr :id="'f_'+item.row_num" v-for="(item, index) in list_role" :key="index">
							<td>{{ item.row_num }}</td>
							<td class="long1 left">{{ item.name }}</td>
							<td>
								<input type="checkbox" v-model="item.sel" v-on:change="sel_push(item)" />
							</td>
						</tr>
					</tbody>
				</table> -->
			</div>
			<div>
				<table class="dataintable">
					<thead>
						<tr class="tab_header">
							<th>序号</th>
							<th class="long1">二级菜单</th>
							<th class="long1">一级菜单</th>
							<th class="menu_btn">新建</th>
							<th class="menu_btn">删除</th>
							<th class="menu_btn">修改</th>
							<th class="menu_btn">查询</th>
							<!-- <th class="menu_btn">保存</th> -->
							<th class="menu_btn">提交</th>
							<th class="menu_btn">作废</th>
							<th class="menu_btn">导出</th>
							<th class="short0">文件上传</th>
							<th class="short0">文件预览</th>
							<th class="short0">文件删除</th>
							<th class="menu_btn">简单</th>
							<th class="menu_btn">复杂</th>
							<th class="menu_btn">全选</th>
							<th class="short0">编辑</th>
						</tr>
					</thead>
					<tbody class="tab_body">
						<tr :id="'f_'+item.row_num" v-for="(item, index) in list_menu" :key="index"
							v-show="fun_check_editbtn(item.m_name)">
							<td>{{ item.row_num }}</td>
							<td class="long1 left">{{ item.m_name }}</td>
							<td class="long1 left">{{ item.m_note }}</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.add" v-on:change="sel_menu(item)" />
							</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.del" v-on:change="sel_menu(item)" />
							</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.upd" v-on:change="sel_menu(item)" />
							</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.sel" v-on:change="sel_menu(item)" />
							</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.sub" v-on:change="sel_menu(item)" />
							</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.bad" v-on:change="sel_menu(item)" />
							</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.exl" v-on:change="sel_menu(item)" />
							</td>
							<td class="short0">
								<input type="checkbox" v-model="item.fileup" v-on:change="sel_menu(item)" />
							</td>
							<td class="short0">
								<input type="checkbox" v-model="item.filelook" v-on:change="sel_menu(item)" />
							</td>
							<td class="short0">
								<input type="checkbox" v-model="item.filedel" v-on:change="sel_menu(item)" />
							</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.easy" v-on:change="sel_menu(item,'easy')" />
							</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.more" v-on:change="sel_menu(item,'more')" />
							</td>
							<td class="menu_btn">
								<input type="checkbox" v-model="item.all" v-on:change="sel_menu(item,'all')" />
							</td>
							<td class="short0">
								<button @click="fun_save_menu(item)">保存</button>
							</td>
						</tr>
					</tbody>
				</table>
			</div>

		</div>
	</div>
</template>

<script>
	import t from '@/utils/type.js'
	import mystore from '@/utils/localstore.js';
	import {
		Method_EasySelect,
		Method_EasyUpdate,
		Method_EasyAdd,
		Method_CommonLong,
		Method_TableAll
	} from '@/utils/loadhttpdata.js';

	import {
		Word_Right_Delete,
		JsonCheck,JsonStr
	} from '@/utils/method.js';
	// const url = require("@/assets/verify/images/1.jpg");
	export default {
		components: {
			'pre-select': () => import("../per_old/pre_select_one.vue")
		},
		data() {
			return {
				fullscreenLoading: false,
				comtype: [],
				sel_comtypename: {},
				sel_comtypeID: '2',
				sel_ok_value: "",

				show_power: true,
				show_edit: false,
				show_button_edit: false,
				btn_name: '编辑名称',

				menu_one: [],
				m_one_id: '',
				m_one_name: '',
				m_one_val: '',
				m_one_step: '',
				m_one_btn: '新增',
				m_one_action: 'data_m_one_add',
				sel_one: [],
				sel_one_name: {},
				sel_one_id: 0,
				sel_one_val: '',

				menu_two: [],
				m_two_id: '',
				m_two_name: '',
				m_two_no: '',
				m_two_val: '',
				m_two_step: '',
				m_two_btn: '新增',
				m_two_action: 'data_m_two_add',

				menu_btn: [],
				isEasy: true,
				isMore: true,
				isAll: true,

				show_data: false,
				tabdata: [],
				tabdataBak:[],
				userno: '',
				rowid: '',
				msg_obj: {},

				show_more: false,
				check_r_names: '',
				check_list: [],
				list_role: [],

				list_menu: [],

				list_user: []


				// path:this.$router.currentRoute.path,
			};
		},
		created: function() {
			this.userno = mystore.getTempParm('userno');
			this.loaddata();
		},
		mounted: function() {
			// this.$nextTick(function(ischeck) {

			// });
			// 这里只是操作dom
		},
		watch: {
			// 这里写方法会影响性能
		},
		methods: {
			fun_checkbox: function(d) {
				return d == '0' ? false : true;
			},
			look_note: function() {
				//收缩区 收放设置
				this.show_note = this.show_note ? false : true;
				if (this.show_note) {
					$("#notice").slideDown("slow");
				} else {
					$("#notice").slideUp("slow");
				}
			},
			selectFunc: function(parm) {
				// console.log('选择结果='+parm);
				this.sel_ok_value = parm;
				this.selcomtype(parm);
				this.loadRoleUser();

			},
			selectMenuOne: function(parm) {
				// console.log('选择结果1=', parm);
				// console.log(this.menu_btn);
				this.sel_one_val = '';
				for (let i = 0; i < this.sel_one.length; i++) {
					if (this.sel_one[i].id == parm) {
						this.sel_one_val = this.sel_one[i].val;
						break;
					}
				}
				
				this.tabdataBak = [];
				
				if (this.sel_one_val != '') {
					for (let i = 0; i < this.tabdata.length; i++) {
						if ((this.tabdata[i].m_note).indexOf(this.sel_one_val) >= 0) {
							// console.log('筛选 m_name=' + this.tabdata[i].m_name + ' level=' + this.tabdata[i].m_note);
							this.tabdataBak.push(this.tabdata[i]);
						}
					}
				} else {
					this.tabdataBak = this.tabdata;
				}
				// console.log('选择结果2=' + this.sel_one_val);
			},
			fun_check_editbtn: function(tname) {
				// console.log('对比项目=' + this.sel_one_val);
				var ts = true;
				if (this.sel_one_val != '') {
					if (tname == this.sel_one_val) {
						ts = true;
					} else {
						ts = false;
					}
				}
				return ts;
			},
			loaddata: function() {
				this.loadRoleName();
				this.loadRoleMenu();
				this.loadMenuOne();
				this.loadMenuTwo();
			},
			loadRoleName: function() {
				this.$post(
					t.http_method, Method_EasySelect('data_role')
				).then(res => {
					// console.log(res);
					res = JSON.parse(res);
					// console.log(res.data.data);
					if (res.data.status == 1) {
						this.comtype = res.data.data;
					}
				});
			},
			loadRoleMenu: function() {
				// console.log('角色ID='+this.sel_comtypeID+' '+this.sel_ok_value)
				this.tabdata = [];
				this.tabdataBak = [];
				
				this.$post(
					t.http_method, Method_EasySelect('getmenu_onerole', this.sel_comtypeID)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res.data.data);
					if (res.data.status == 1) {
						var data = [];
						for (var i = 0; i < res.data.data.length; i++) {
							var obj = {};
							obj.id = i + 1;
							obj.m_id = res.data.data[i].id;
							obj.child_id = res.data.data[i].child_id;
							obj.m_name = res.data.data[i].name;
							obj.m_note = res.data.data[i].note;
							obj.r_id = res.data.data[i].flag_power;

							if (Number(res.data.data[i].flag_power) > 0) {
								obj.m_has = '是';
								obj.state = true;
							} else {
								obj.m_has = '否';
								obj.state = false;
							}
							data[i] = obj;
						}
						this.tabdata = data;
						this.tabdataBak = data;

					} else {
						this.msg_obj = {
							'showtype': 'err',
							'note': res.data.message
						};
					}
					// this.comtype=res.data.data;
				});


			},
			loadRoleUser: function() {
				this.list_user = [];
				this.$post(
					t.http_method, Method_EasySelect('_base_roleuser', this.sel_comtypeID)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res.data.data);
					if (res.data.status == 1) {
						for (var i = 0; i < res.data.data.length; i++) {
							var obj = {};
							obj.id = i + 1;
							obj.u_name = res.data.data[i].val
							this.list_user.push(obj);
						}
					} else {
						this.msg_obj = {
							'showtype': 'err',
							'note': res.data.message
						};
					}
					// this.comtype=res.data.data;
				});
			},
			selcomtype: function(value) {
				// console.log('role_id='+value);
				// console.log(this.comtype);
				this.sel_comtypeID = value;

				// for(var i=0;i<this.comtype.length;i++){
				//     if(this.comtype[i].val==value){
				//         this.sel_comtypeID=this.comtype[i].id;
				//         break;
				//     }
				// }
				// console.log('选择发布类型='+this.sel_comtypeID);
				this.loadRoleMenu();
				this.loadMenuButton();
			},
			select_menu: function(row) {
				// console.log(row);

				this.$post(
					t.http_method, Method_EasyUpdate('datamenudata', 0, this.sel_comtypeID, row.m_id, row.child_id)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res)
					this.$message({
						message: res.data.msg,
						type: 'success'
					})
					// this.loadRoleMenu();
				});
			},
			select_menu_btn: function(rowid, type, val) {
				// console.log('修改 id='+rowid+' : '+type+' = '+val);
				let flag = false;
				switch (type) {
					case 'easy':
						if (this.isEasy) {
							flag = '1';
							this.isEasy = false;
						} else {
							flag = '0';
							this.isEasy = true;
						}
						break;
					case 'more':
						if (this.isMore) {
							flag = '1';
							this.isMore = false;
						} else {
							flag = '0';
							this.isMore = true;
						}
						break;
					case 'all':
						if (this.isAll) {
							flag = '1';
							this.isAll = false;
						} else {
							flag = '0';
							this.isAll = true;
						}
						break;
					default:
						flag = (val == true ? '1' : '0');
						break;
				}

				this.$post(
					t.http_method, Method_EasyUpdate('datamenubutton', rowid, type, flag)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res)
					this.$message({
						message: res.data.msg,
						type: 'success'
					})
					this.loadMenuButton();
				});


			},
			fun_show: function() {
				if (this.btn_name == '编辑名称') {
					this.show_edit = true;
					this.show_power = false;
					this.btn_name = '编辑权限';
				} else {
					this.show_power = true;
					this.show_edit = false;
					this.btn_name = '编辑名称';
				}
				this.show_button_edit = false;
				this.show_more = false;
			},
			fun_showbtn: function() {
				this.show_power = false;
				this.show_edit = false;
				this.show_button_edit = true;
				this.show_more = false;
				this.loadMenuButton();
			},
			fun_showmore: function() {
				this.show_power = false;
				this.show_edit = false;
				this.show_button_edit = false;
				this.show_more = true;

				this.list_role = [];
				this.check_list = [];
				for (let i = 0; i < this.comtype.length; i++) {
					var o = {};
					o.id = this.comtype[i].id;
					o.row_num = i + 1;
					o.name = this.comtype[i].val;
					o.sel = false;
					this.list_role.push(o);
				}

				// console.log(this.tabdata);
				this.list_menu = [];
				for (let i = 0; i < this.tabdata.length; i++) {
					var o = {};
					o.id = this.tabdata[i].id;
					o.row_num = i + 1;
					o.m_id = this.tabdata[i].m_id;
					o.child_id = this.tabdata[i].child_id;
					o.m_name = this.tabdata[i].m_name;
					let t = '';
					t = this.tabdata[i].m_note;

					t = t.substr(t.indexOf('：') + 1);

					o.m_note = t;
					o.add = false;
					o.del = false;
					o.upd = false;
					o.sel = false;
					o.sav = false;
					o.sub = false;
					o.exl = false;
					o.fileup = false;
					o.filelook = false;
					o.filedel = false;
					o.bad = false;
					o.easy = false;
					o.more = false;
					o.all = false;
					this.list_menu.push(o);
				}
			},
			sel_menu: function(item, type) {
				// console.log(item);
				// console.log('修改 id='+rowid+' : '+type+' = '+val);
				let id = 0
				id = item.id;

				for (let i = 0; i < this.list_menu.length; i++) {
					if (this.list_menu[i].id == id) {
						if (type == 'easy') {
							if (item.easy) {
								this.list_menu[i].add = true;
								this.list_menu[i].del = true;
								this.list_menu[i].upd = true;
								this.list_menu[i].sel = true;
							} else {
								this.list_menu[i].add = false;
								this.list_menu[i].del = false;
								this.list_menu[i].upd = false;
								this.list_menu[i].sel = false;
							}
						} else if (type == 'more') {
							if (item.more) {
								this.list_menu[i].add = true;
								this.list_menu[i].del = true;
								this.list_menu[i].upd = true;
								this.list_menu[i].sel = true;
								this.list_menu[i].sub = true;
								this.list_menu[i].bad = true;
							} else {
								this.list_menu[i].add = false;
								this.list_menu[i].del = false;
								this.list_menu[i].upd = false;
								this.list_menu[i].sel = false;
								this.list_menu[i].sub = false;
								this.list_menu[i].bad = false;
							}
						} else if (type == 'all') {
							if (item.all) {
								this.list_menu[i].add = true;
								this.list_menu[i].del = true;
								this.list_menu[i].upd = true;
								this.list_menu[i].sel = true;
								this.list_menu[i].sub = true;
								this.list_menu[i].bad = true;
								this.list_menu[i].exl = true;
								this.list_menu[i].sav = true;
								this.list_menu[i].fileup = true;
								this.list_menu[i].filelook = true;
								this.list_menu[i].filedel = true;
							} else {
								this.list_menu[i].add = false;
								this.list_menu[i].del = false;
								this.list_menu[i].upd = false;
								this.list_menu[i].sel = false;
								this.list_menu[i].sub = false;
								this.list_menu[i].bad = false;
								this.list_menu[i].exl = false;
								this.list_menu[i].sav = false;
								this.list_menu[i].fileup = false;
								this.list_menu[i].filelook = false;
								this.list_menu[i].filedel = false;
							}
						}
					}
				}

			},
			fun_save_menu: async function(item) {
				console.log(item);
				console.log(this.check_r_names + ' type=' + typeof(this.check_r_names));
				if (typeof(this.check_r_names) === undefined || this.check_r_names == '') {
					this.$message({
						message: '请选择要修改的角色!',
						type: 'warning'
					});
					return;
				}

				let t_role_id = 0,
					t_m_id = 0,
					t_c_id = 0;
				let t_add = '0',
					t_del = '0',
					t_upd = '0',
					t_sel = '0',
					t_sub = '0',
					t_bad = '0',
					t_exl_down = '0',
					t_exl_up = '0',
					t_print = '0',
					t_fileup = '0',
					t_filelook = '0',
					t_filedel = '0';

				t_m_id = item.m_id;
				t_c_id = item.child_id;
				t_add = (item.add == true ? '1' : '0');
				t_del = (item.del == true ? '1' : '0');
				t_upd = (item.upd == true ? '1' : '0');
				t_sel = (item.sel == true ? '1' : '0');

				t_sub = (item.sub == true ? '1' : '0');
				t_bad = (item.bad == true ? '1' : '0');
				t_exl_down = (item.exl_down == true ? '1' : '0');
				t_exl_up = (item.exl_up == true ? '1' : '0');
				t_print = (item.print == true ? '1' : '0');
				t_fileup = (item.fileup == true ? '1' : '0');
				t_filelook = (item.filelook == true ? '1' : '0');
				t_filedel = (item.filedel == true ? '1' : '0');

				for (let i = 0; i < this.list_role.length; i++) {

					if (this.list_role[i].sel) {
						t_role_id = 0;
						t_role_id = this.list_role[i].id;

						let d = [];
						d.push(t_role_id);
						d.push(t_m_id);
						d.push(t_c_id);
						d.push(t_add);
						d.push(t_del);
						d.push(t_upd);
						d.push(t_sel);

						d.push(t_sub);
						d.push(t_bad);
						d.push(t_exl_down);
						d.push(t_exl_up);
						d.push(t_print);
						d.push(t_fileup);
						d.push(t_filelook);
						d.push(t_filedel);

						let res = await this.fun_submit_menu(d);
						console.log(res);
						let back_type = 'warning';
						if (res.status == '1') {
							back_type = 'success';
						}

						this.$message({
							message: '菜单:' + item.m_name + '\r\n' + res.msg,
							type: back_type
						});

					}
				}

			},
			fun_submit_menu: function(d) {
				let that = this;
				let r = (Math.random() + '').substring(0, 8);
				return new Promise((resolve, reject) => {
					// console.log(menuvalue);
					that.$post(
						t.http_method, Method_CommonLong('data_menu_set', 0, '', d, r)
					).then(res => {
						res = JSON.parse(res);
						resolve(res.data)
					});
				});
			},
			fun_sel_is_all: function(type) {
				// console.log(this.list_role);
				this.check_list = [];
				if (type == '1') {
					for (let i = 0; i < this.list_role.length; i++) {
						this.list_role[i].sel = true;
						this.check_list.push(this.list_role[i].name);
					}
				} else {
					for (let i = 0; i < this.list_role.length; i++) {
						this.list_role[i].sel = false;
					}
				}
				this.check_r_names = '';
				this.check_r_names = this.check_list.toString();

			},
			sel_push: function(item) {
				console.log(item);
				console.log('push_id=' + item.id + ' tab_val=' + item.name + ' checked=' + item.sel);
				if (item.sel) {
					let index = 0;
					index = this.check_list.indexOf(item.name);
					if (index >= 0) {
						this.check_list.splice(index, 1);
					}
				}
				// else {

				// 	this.check_list.push(item.name);
				// }
				console.log(this.check_list.toString());
				this.check_r_names = '';
				this.check_r_names = this.check_list.toString();

			},
			loadMenuButton: function() {
				this.$post(
					t.http_method, Method_EasySelect('data_menu_btn', this.sel_comtypeID)
				).then(res => {
					// console.log(res)
					if (res !== undefined) {
						// console.log(res)
						res = JSON.parse(res);
						// console.log(res.data.data);
						if (res.data.status == 1) {
							this.menu_btn = [];
							var data = [];
							for (var i = 0; i < res.data.data.length; i++) {
								var obj = {};
								obj.rowid = res.data.data[i].id;
								obj.id = res.data.data[i].row_num;
								obj.m_name = res.data.data[i].m_name;
								obj.m_note = res.data.data[i].m_note;
								obj.m_add = (res.data.data[i].m_add == '0' ? false : true);
								obj.m_del = (res.data.data[i].m_del == '0' ? false : true);
								obj.m_upd = (res.data.data[i].m_upd == '0' ? false : true);
								obj.m_sel = (res.data.data[i].m_sel == '0' ? false : true);

								obj.m_sub = (res.data.data[i].m_sub == '0' ? false : true);
								obj.m_bad = (res.data.data[i].m_bad == '0' ? false : true);
								obj.m_exl_down = (res.data.data[i].m_exl_down == '0' ? false : true);
								obj.m_exl_up = (res.data.data[i].m_exl_up == '0' ? false : true);
								obj.m_print = (res.data.data[i].m_print == '0' ? false : true);
								obj.m_fileup = (res.data.data[i].m_fileup == '0' ? false : true);
								obj.m_filelook = (res.data.data[i].m_filelook == '0' ? false : true);
								obj.m_filedel = (res.data.data[i].m_filedel == '0' ? false : true);

								data[i] = obj;
							}
							this.menu_btn = data;



						} else {
							this.msg_obj = {
								'showtype': 'err',
								'note': res.data.message
							};
						}
					}
				});
			},
			loadMenuOne: function() {
				this.$post(
					t.http_method, Method_EasySelect('data_menu_one')
				).then(res => {
					res = JSON.parse(res);
					// console.log(res.data.data);
					if (res.data.status == 1) {
						this.menu_one = [];
						this.sel_one = [];
						for (var i = 0; i < res.data.data.length; i++) {
							var obj = {};
							obj.id = res.data.data[i].row_num;
							obj.rowid = res.data.data[i].id;
							obj.name = res.data.data[i].label;
							obj.val = res.data.data[i].value;
							obj.step = res.data.data[i].step;

							var ts = {};
							ts.id = res.data.data[i].id;
							ts.val = res.data.data[i].label;

							this.menu_one.push(obj);
							this.sel_one.push(ts);
						}

					} else {
						this.msg_obj = {
							'showtype': 'err',
							'note': res.data.message
						};
					}
				});
			},
			fun_menu_one_edit: function(item, type) {
				console.log(item);
				console.log(type)
				if (type == 'upd') {
					this.m_one_id = item.rowid;
					this.m_one_name = item.name;
					this.m_one_val = item.val;
					this.m_two_no = item.no;
					this.m_one_step = item.step;
					this.m_one_btn = '修改'
					this.m_one_action = 'data_m_one_' + type;
					this.loadMenuTwo();
				} else if (type == 'add') {
					this.m_one_id = '';
					this.m_one_name = '';
					this.m_one_val = '';
					this.m_two_no = '';
					this.m_one_step = '';
					this.m_one_btn = '新增'
					this.m_one_action = 'data_m_one_' + type;
				} else if (type == 'del') {
					this.m_one_id = item.rowid;
					this.m_one_name = item.name;
					this.m_one_val = item.val;
					this.m_one_step = item.step;
					this.m_one_btn = '确定删除'
					this.m_one_action = 'data_m_one_' + type;
				} else {
					this.m_one_id = item.rowid;
					this.m_one_name = item.name;
					this.m_one_val = item.val;
					this.m_two_no = item.no;
					this.m_one_step = item.step;
					this.m_one_btn = '确定删除'
					this.m_one_action = 'data_m_one_' + type;
				}

			},
			loadMenuTwo: function() {
				if (Number(this.m_one_id) == 0) {
					this.m_one_id = 1;
				}
				this.$post(
					t.http_method, Method_EasySelect('data_menu_two', this.m_one_id)
				).then(res => {
					res = JSON.parse(res);
					// console.log(res.data.data);
					this.menu_two = [];
					if (res.data.status == 1) {
						for (var i = 0; i < res.data.data.length; i++) {
							var obj = {};
							obj.id = res.data.data[i].row_num;
							obj.rowid = res.data.data[i].id;
							obj.name = res.data.data[i].label;
							obj.val = res.data.data[i].value;
							obj.no = res.data.data[i].no;
							obj.step = res.data.data[i].step;
							this.menu_two.push(obj);
						}
					} else {
						this.msg_obj = {
							'showtype': 'err',
							'note': res.data.message
						};
					}
				});

			},
			fun_menu_two_edit: function(item, type) {
				// console.log(item);
				if (type == 'upd') {
					this.m_two_id = item.rowid;
					this.m_two_name = item.name;
					this.m_two_val = item.val;
					this.m_two_step = item.step;
					this.m_two_btn = '修改'
					this.m_two_action = 'data_m_two_' + type;
					this.loadMenuTwo();
				} else if (type == 'add') {
					this.m_two_id = '';
					this.m_two_name = '';
					this.m_two_val = '';
					this.m_two_step = '';
					this.m_two_btn = '新增'
					this.m_two_action = 'data_m_two_' + type;
				} else {
					this.m_two_id = item.rowid;
					this.m_two_name = item.name;
					this.m_two_val = item.val;
					this.m_two_step = item.step;
					this.m_two_btn = '确定删除'
					this.m_two_action = 'data_m_two_' + type;
				}

			},
			fun_menu_edit_one: function() {
				// console.log('操作。。。。。。。。。');
				this.$post(
					t.http_method, Method_EasyAdd(this.m_one_action, this.m_one_name, this.m_one_val, this
						.m_one_step, this
						.m_one_id)
				).then(res => {
					res = JSON.parse(res);
					console.log(res)
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
					if (res.data.status == '1') {
						this.loadMenuOne();
					}
				});
			},
			fun_menu_edit_two: function() {
				if (this.m_two_name.length > 8) {
					this.m_two_name = this.m_two_name.substring(0, 8);
				}

				let trans_data = '';
				if (typeof(this.m_two_no) !== 'undefined' && this.m_two_no != '') {
					console.log('m_one_id=' + this.m_one_id + ' m_two_name=' + this.m_two_name);
					let parm = '';
					parm =
						'menu_id=' + Word_Right_Delete(this.m_one_id) + '^' +
						'menu_no=' + Word_Right_Delete(this.m_two_no) + '^' +
						'menu_name=' + Word_Right_Delete(this.m_two_name) + '^' +
						'menu_value=' + Word_Right_Delete(this.m_two_val) + '^' +
						'page_no=' + Word_Right_Delete('') + '^' +
						'step=' + Word_Right_Delete(this.m_two_step);
					console.log(parm);
					trans_data = Method_TableAll(this.m_two_action, this.m_two_no, this.m_two_id, this.m_two_sys_date,
						parm);
				} else {
					trans_data = Method_EasyAdd(this.m_two_action, this.m_two_name, this.m_two_val, this.m_two_step,
						this.m_one_id, this.m_two_id);
				}

				this.$post(
					t.http_method, trans_data
				).then(res => {
					res = JSON.parse(res);
					// console.log(res);
					this.$message({
						message: res.data.msg,
						type: 'success'
					});
					if (res.data.status == '1') {
						this.loadMenuTwo();
					}
				});
			}


		}
	};
</script>
<style scoped>
	.select_user {
		text-align: left;
		display: inline-block;
		margin-bottom: 8px;
	}

	.select_user>div {
		padding-top: 5px;
		width: auto;
		height: 32px;
		line-height: 32px;
		display: inline-block;
		vertical-align: center;
	}

	/* 编辑部分 */
	.menu_left {
		display: inline-block;
		/* width: 40%; */
		min-width: 400px;
		/* overflow: auto; */
		vertical-align: top;
	}

	.menu_right {
		display: inline-block;
		width: 40%;
		min-width: 400px;
		/* overflow: auto; */
		vertical-align: top;
		margin-left: 10px;
	}

	.menu_title {
		font-size: 18px;
		text-align: center;
		font-weight: bold;
	}

	.menu_edit_all {
		background: rgb(195, 219, 250);
		padding: 5px;
	}

	.menu_edit {
		margin-top: 5px;
		text-align: left;
	}

	.menu_edit>label {
		display: inline-block;
		width: 48px;
		font-size: 16px;
		margin-left: 20px;
	}

	.menu_edit>input {
		display: inline-block;
		width: 160px;
		font-size: 16px;
	}

	.menu_edit>button {
		color: rgb(241, 235, 235);
		font-size: 16px;
		width: 100px;
		height: 30px;
		background-color: rgba(25, 37, 202, 0.986);
		border-radius: 5px;
		margin-left: 40%;
	}

	.menu_btn {
		min-width: 68px !important;
		width: 68px !important;
	}

	.checkleft {
		margin-left: -48px;
	}

	.more-left {
		display: inline-block;
		width: 272px;
		vertical-align: top;
		overflow: hidden;
	}

	.more-right {
		display: inline-block;
		width: calc(100% - 285px);
		vertical-align: top;
	}

	.tab-inline {
		display: inline-block;
		vertical-align: top;
	}

	.check-list {
		padding-left: 6px;
		padding-top: 2px;
		padding-bottom: 6px;
	}
</style>